<template>
	<poplist class="omni-tab" :class="{ on: active }">
		<template slot="fuze">{{currentTab}}<i class="icon-downArrow"></i></template>
		<itemlist>
			<li v-for="(tab, key) in tablist" @click="handleClick(key, tab)">{{ tab }}</li>
		</itemlist>
	</poplist>
</template>
<script>
	export default {
		name: 'omniTab',
		props: {
			tablist: {
				type: Array
			},
			currentTab: {
				type: String
			}
		},
		data() {
			return {
				index: 0,
				active: false
			}
		},
		methods: {
			handleClick(key, tab) {
				this.index = key
				this.currentTab = tab
				this.tablist.remove(tab)
				var auxtab = this.tablist.unshift(tab);
				this.active = true
			}
		},
        mounted() {
        	if (!this.currentTab) this.currentTab = this.tablist[0]
        }

	}
</script>


// WEBPACK FOOTER //
// src/components/tabBar/omniTab.vue